export interface HeroFeature {
    titleKey: string;
    descKey: string;
}

export const heroFeatures: HeroFeature[] = [
    {
        titleKey: 'ai-studio.features.zero_wait.title',
        descKey: 'ai-studio.features.zero_wait.desc',
    },
    {
        titleKey: 'ai-studio.features.reduced_admin.title',
        descKey: 'ai-studio.features.reduced_admin.desc',
    },
    {
        titleKey: 'ai-studio.features.easy_setup.title',
        descKey: 'ai-studio.features.easy_setup.desc',
    },
];
